import { Center, Loader, Stack, Title } from "@mantine/core";
import { SiemensLogo } from "../assets/SiemensLogo";

const APP_TITLE = import.meta.env.VITE_APP_TITLE ?? "Knowledge Search";

export const LoadingScreen = () => {
    return (
        <Center h="100vh" w="100vw" bg="gray.0">
            <Stack align="center" gap="xl">
                <SiemensLogo width={120} height={42} />
                <Title order={3} c="purple.8" fw={500}>
                    {APP_TITLE}
                </Title>
                <Loader size="lg" type="bars" color="purple.6" />
            </Stack>
        </Center>
    );
};
